import Bee from "../assets/Bee";
import CarrierBee from "../assets/CarrierBee";
import Logo from "../assets/Logo";
import Feed1 from "../assets/feed1.png";
import Feed2 from "../assets/feed2.png";
import Feed3 from "../assets/feed3.png";
import Feed4 from "../assets/feed4.png";
import banner from "../assets/banner.png";
import { useState } from "react";

function MainPage() {
    return (
        <div style={{
            width: '100vw',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: '300px',
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                height: '300px',
                width: '100%',
                backgroundColor: '#6DDA85',
                marginTop: '50px',
                gap: '30px',
                paddingLeft: '50px',
                paddingRight: '50px'
            }}>
                <Bee style={{ width: '150px', height: '150px' }} />
                <Logo style={{ width: '224px', height: '87px' }} />
            </div>
            <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                gap: '25px',
                width: '80%',
                maxWidth: '1000px',
                marginTop: '50px',
            }}>
                <h1 style={{ fontSize: '30px', fontWeight: '700', fontFamily: 'TmoneyRoundWindExtraBold' }}>경비 정산이 필요한 순간!</h1>
                <div style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    gap: '10px',
                    width: '100%',
                }}>
                    <h1 style={{ fontSize: '16px', fontWeight: '400', fontFamily: 'TmoneyRoundWind' }}>만나서 반가워요!</h1>
                    <h1 style={{ fontSize: '16px', fontWeight: '400', fontFamily: 'TmoneyRoundWind' }}>저는 모두를 위한 여행 비서 <span style={{ fontFamily: 'TmoneyRoundWindExtraBold' }}>여비</span>에요💫</h1>
                </div>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                }}>
                    <CarrierBee style={{ width: '480px', height: '213px', marginTop: '20px' }} />
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    gap: '10px',
                    width: '100%',
                    borderLeft: '3px solid black',
                    paddingLeft: '20px',
                    paddingTop: '5px',
                    paddingBottom: '5px'
                }}>
                    <h1 style={{ fontSize: '16px', fontWeight: '400', fontFamily: 'TmoneyRoundWind' }}>아직도</h1>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        gap: '5px',
                        width: '100%',
                    }}>
                        <h1 style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            fontFamily: 'TmoneyRoundWind',
                            color: 'rgb(15, 123, 108)',
                            backgroundColor: 'rgba(135, 131, 120, 0.15)',
                            padding: '0.2em 0.4em',
                            borderRadius: '3px'
                        }}>여행 전</h1>
                        <h1 style={{ fontSize: '16px', fontWeight: '400', fontFamily: 'TmoneyRoundWind' }}>계획을 엑셀에 정리하시나요?</h1>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        gap: '5px',
                        width: '100%',
                    }}>
                        <h1 style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            fontFamily: 'TmoneyRoundWind',
                            color: '#EB5757',
                            backgroundColor: 'rgba(135, 131, 120, 0.15)',
                            padding: '0.2em 0.4em',
                            borderRadius: '3px'
                        }}>여행 중</h1>
                        <h1 style={{ fontSize: '16px', fontWeight: '400', fontFamily: 'TmoneyRoundWind' }}>지출을 메모장에 기록하시나요?</h1>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        gap: '5px',
                        width: '100%',
                    }}>
                        <h1 style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            fontFamily: 'TmoneyRoundWind',
                            color: 'rgb(11, 110, 153)',
                            backgroundColor: 'rgba(135, 131, 120, 0.15)',
                            padding: '0.2em 0.4em',
                            borderRadius: '3px'
                        }}>여행 후</h1>
                        <h1 style={{ fontSize: '16px', fontWeight: '400', fontFamily: 'TmoneyRoundWind' }}>정산으로 머리가 아프신가요?</h1>
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    gap: '10px',
                    width: '100%',
                    backgroundColor: 'rgb(237, 243, 236)',
                    padding: '20px',
                    borderRadius: '12px'
                }}>
                    <h1 style={{ fontSize: '16px', fontWeight: '600', fontFamily: 'TmoneyRoundWindExtraBold' }}>💸 이제 해외여행 돈 관리는 <span style={{ color: 'rgb(15, 123, 108)' }}>여비</span>로 해결하세요!</h1>
                </div>
            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                gap: '10px',
                width: '80%',
                maxWidth: '1000px',
                marginTop: '50px',
            }}>
                <img src={Feed1} style={{ width: '100%', height: '100%', borderRadius: '12px' }} />
                <img src={Feed2} style={{ width: '100%', height: '100%', borderRadius: '12px' }} />
                <img src={Feed3} style={{ width: '100%', height: '100%', borderRadius: '12px' }} />
                <img src={Feed4} style={{ width: '100%', height: '100%', borderRadius: '12px' }} />
            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                width: '80%',
                maxWidth: '1000px',
                marginTop: '20px',
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '1px',
                    width: '100%',
                    backgroundColor: 'rgb(228, 227, 226)',
                    marginBottom: '50px'
                }} />
                <h1 style={{ fontSize: '30px', fontWeight: '600', fontFamily: 'TmoneyRoundWindExtraBold' }}>이런분들께 추천해요!</h1>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    gap: '15px',
                    width: '100%',
                    borderLeft: '3px solid black',
                    paddingLeft: '20px',
                    paddingTop: '5px',
                    paddingBottom: '5px',
                    marginTop: '20px'
                }}>
                    <h1 style={{ fontSize: '16px', fontWeight: '600', fontFamily: 'TmoneyRoundWind' }}>✅ 여행 중 총무를 담당 하신 분! (강추💫)</h1>
                    <h1 style={{ fontSize: '16px', fontWeight: '600', fontFamily: 'TmoneyRoundWind' }}>✅ 친구와 깔끔하게 정산하고 싶은 분!</h1>
                    <h1 style={{ fontSize: '16px', fontWeight: '600', fontFamily: 'TmoneyRoundWind' }}>✅ 경비 엑셀 정리헤서 벗어나고 싶은 분!</h1>
                </div>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '1px',
                    width: '100%',
                    backgroundColor: 'rgb(228, 227, 226)',
                    marginTop: '20px',
                    marginBottom: '50px'
                }} />
                <h1 style={{ fontSize: '30px', fontWeight: '600', fontFamily: 'TmoneyRoundWindExtraBold' }}>여비 다운로드 받기</h1>
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    gap: '10px',
                    width: '100%',
                    padding: '20px',
                    border: '1px solid rgba(55, 53, 47, 0.09)',
                    borderRadius: '12px',
                    marginTop: '20px',
                    marginBottom: '40px'
                }}>
                    <h1 style={{ fontSize: '16px', fontWeight: '600', fontFamily: 'TmoneyRoundWind' }}>💫   지금 바로 app store에서 ‘여비’를 검색해보세요!</h1>
                </div>
                <img src={banner} style={{ width: '100%', height: '100%', marginBottom: '40px' }} />
                <Toggle
                    title="서비스이용약관"
                    description="서비스 이용약관 설명에 앞서 '여비' 서비스를 이용해주셔서 감사합니다!  저희 '여비'는 여러분의 여행 경비를 더욱 간편하고 쉽게 관리할 수 있도록 여행만을 위한 정산 가계부..."
                    url="https://cafe.naver.com/yeobee/6"
                />
                <Toggle
                    title="개인정보처리방침"
                    description="개인정보 처리방침 ('https://yeobee.oopy.io/ '이하 '여비') 은(는) 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 ..."
                    url="https://cafe.naver.com/yeobee/2"
                />
            </div>

            <div style={{
                position: 'fixed',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                width: '80%',
                maxWidth: '1000px',
                bottom: '40px',
                zIndex: 1000,
                marginLeft: 'auto',
                marginRight: 'auto',
            }}>
                <a href="https://apps.apple.com/us/app/%EC%97%AC%EB%B9%84-%EC%97%AC%ED%96%89%EA%B2%BD%EB%B9%84-%EA%B8%B0%EB%A1%9D%EB%B6%80%ED%84%B0-%EC%A0%95%EC%82%B0%EA%B9%8C%EC%A7%80/id6475346701"
                    target="_blank" rel="noopener noreferrer"
                    style={{
                        width: '100%',
                        height: '50px',
                        borderRadius: '12px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '24px',
                        backgroundColor: 'black'
                    }}>
                    <h1 style={{ fontSize: '16px', fontWeight: '600', fontFamily: 'TmoneyRoundWindExtraBold' }}>
                        다운로드 하기
                    </h1>
                </a>
            </div>
        </div>
    )
}

function Toggle({ title, description, url }: { title: string, description: string, url: string }) {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            gap: '10px',
        }}>
            <div
                onClick={() => setIsExpanded(!isExpanded)}
                style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '10px'
                }}
            >
                <span style={{
                    transform: `rotate(${isExpanded ? '90deg' : '0deg'})`,
                    transition: 'transform 0.3s ease',
                    display: 'inline-block'
                }}>
                    ▶
                </span>
                <h2 style={{ fontSize: '16px', fontWeight: '600', fontFamily: 'TmoneyRoundWind' }}>
                    {title}
                </h2>
            </div>

            {isExpanded && (
                <>
                    <Link metadata={{ title: title, description: description, url: url }} />
                </>
            )}
        </div>
    )
}

function Link({ metadata }: { metadata: { title: string, description: string, url: string } }) {
    return (
        <>
            <a
                href={metadata.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    display: 'flex',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: '100%',
                    marginBottom: '20px'
                }}
            >
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    paddingLeft: '15px',
                    paddingRight: '15px',
                    paddingTop: '15px',
                    paddingBottom: '15px',
                    width: '100%',
                }}>
                    <h2 style={{ margin: '0 0 10px', fontSize: '14px', fontWeight: '600', fontFamily: 'TmoneyRoundWind', color: 'black' }}>{metadata.title}</h2>
                    <p style={{ margin: '0 0 5px', color: '#666', fontSize: '12px', fontWeight: '400', fontFamily: 'TmoneyRoundWind' }}>{metadata.description}</p>
                    <h1
                        style={{ fontSize: '10px', fontWeight: '400', fontFamily: 'TmoneyRoundWind', color: 'black' }}
                    >
                        {metadata.url}
                    </h1>
                </div>
                {
                    window.innerWidth > 768 && (
                        <img
                            src="https://oopy.lazyrockets.com/api/v2/notion/image?src=https%3A%2F%2Fcafe.pstatic.net%2Fimg%2Fsns%2Fcafe_ogtag_270x270_160618.png&blockId=f14e7daa-d71a-4341-9398-a8d474595c0c&width=512"
                            alt="Preview"
                            style={{ width: '180px', height: '150px', objectFit: 'cover' }}
                        />
                    )
                }
            </a>
        </>
    )
}

export default MainPage;

